module.exports = __webpack_public_path__ + "media/customizations/santaritaranch/back-52dd7b83d10f36a34d8012080173516d.jpg";